import { DashboardWidgetData } from 'features/widget/types'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'

// eslint-disable-next-line import/prefer-default-export
export const retrieveDataset = (response: DashboardWidgetData<AnnotatedMetricResult>) =>
  response?.results?.[0].data.metrics?.[0].dataset || []
